import React from 'react';
import { useAuth } from '../auth/AuthContext';

export default function AccountPage() {
  const { user, logout } = useAuth();
  return (
    <section className="section">
      <div className="section-inner" style={{ maxWidth: 720 }}>
        <div className="section-header">
          <h2>Mon compte</h2>
          <p>Gérez votre profil et votre session.</p>
        </div>
        <div className="card">
          <p><strong>Nom:</strong> {user?.name || '-'} </p>
          <p><strong>Email:</strong> {user?.email || '-'} </p>
          <p><strong>Rôle:</strong> {user?.role || 'user'} </p>
          <div style={{ marginTop: 12 }}>
            <button className="btn btn-ghost" type="button" onClick={logout}>Se déconnecter</button>
          </div>
        </div>
      </div>
    </section>
  );
}
